// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.time-height[data-v-66df4061] {\n  height: 32px;\n}\n.title[data-v-66df4061] {\n  font-size: 13px;\n  margin-bottom: 10px;\n}\n\n/* 隐藏表格的第一行 */\n.hide-first-row[data-v-66df4061] (.el-table__body tr:nth-child(1)) {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
